"use strict";

import PageCommon from "../PageCommon.js";
import Playlist from "./Playlist.js";

import Globals from "../../Globals.js";

export default class Playlists extends PageCommon {
    constructor(props) {
        super();
        this.data = props.map((item) => new Playlist(item));
        this.firstpage = [];
    }

    set(object) {
        this.data = object.map((item) => new Playlist(item));
    }

    get({ id }) {
        if (id) {
            return this.data.filter((playlist) => playlist.get().ID === parseInt(id))[0];
        }
        return this.data;
    }

    getFull(id, tracks, userManager) {
        if (id && tracks) {
            if (Globals.SHOW_ALL_CONSOLE_LOG) console.log("Playlists - getFull");
            const contentWrapper = document.querySelector(`#contentWrapper`);
            if (contentWrapper.querySelector(".js-preloader")) {
                setTimeout((contentWrapper.querySelector(".js-preloader").style.display = ""), 100);
            }
            const found = userManager.userPlaylists.filter((playlist) => playlist.ID === parseInt(id));
            const _this = this;
            fetch(`${Globals.WS_URL}?mode=PLAYLIST&playlist_id=${id}`)
                // fetch(`/apisounzone/getplaylist/` + id)
                .then((response) => response.text())
                .then((json) => JSON.parse(json))
                .then((result) => {
                    const playlistItem = result.data.playlists[0];
                    //  this.SetMeta(playlistItem);
                    if (Globals.SHOW_ALL_CONSOLE_LOG) console.log("Playlists - getFull OK");
                    if (contentWrapper.querySelector(".js-preloader")) {
                        contentWrapper.querySelector(".js-preloader").remove();
                    }
                    contentWrapper.querySelector("#tracksSection").style.display = "";
                    const container = contentWrapper.querySelector(`#playlistSection`);
                    container.style.display = "";
                    const playlist = new Playlist(playlistItem);
                    playlist.renderSingleItem(container, tracks);
                    if (found.length > 0) {
                        contentWrapper.querySelector("button.update").addEventListener("click", (event) => {
                            contentWrapper.querySelector("button.update").style.display = "none";
                            const orderedTracks = Array.from(contentWrapper.querySelectorAll("#tracksSection .tracks-list-body .track-item")).map((item) => item.dataset.id);
                            _this.changeTracksPlaylist(orderedTracks, playlist.data);
                        });

                        let dragging = null;

                        contentWrapper.querySelectorAll("#tracksSection .tracks-list-body .track-item").forEach((trackItem) => {
                            trackItem.draggable = true;

                            // (B2) DRAG START - YELLOW HIGHLIGHT DROPZONES
                            trackItem.addEventListener("dragstart", function (event) {
                                dragging = event.currentTarget.closest(".track-item");
                                dragging.classList.add("hint");
                            });

                            // (B3) DRAG ENTER - RED HIGHLIGHT DROPZONE
                            trackItem.addEventListener("dragenter", function (event) {
                                contentWrapper.querySelectorAll("#tracksSection .tracks-list-body .track-item").forEach((item) => {
                                    item.classList.remove("active");
                                });
                                const current = event.currentTarget.closest(".track-item");
                                if (current !== dragging) {
                                    current.classList.add("active");
                                }
                            });

                            // (B5) DRAG END - REMOVE ALL HIGHLIGHTS
                            trackItem.addEventListener("dragend", function (event) {
                                contentWrapper.querySelectorAll("#tracksSection .tracks-list-body .track-item").forEach((item) => {
                                    item.classList.remove("hint");
                                    item.classList.remove("active");
                                });
                            });

                            // (B6) DRAG OVER - PREVENT THE DEFAULT "DROP", SO WE CAN DO OUR OWN
                            trackItem.addEventListener("dragover", function (event) {
                                event.preventDefault();
                            });

                            // (B7) ON DROP - DO SOMETHING
                            trackItem.addEventListener("drop", function (event) {
                                event.preventDefault();
                                const current = event.currentTarget.closest(".track-item");
                                let currentPosition = 0;
                                let draggingPosition = 0;

                                contentWrapper.querySelectorAll("#tracksSection .tracks-list-body .track-item").forEach((item, index) => {
                                    if (item === current) {
                                        currentPosition = index;
                                    } else if (item === dragging) {
                                        draggingPosition = index;
                                    }
                                });
                                if (currentPosition !== draggingPosition) {
                                    if (currentPosition > draggingPosition) {
                                        current.parentNode.insertBefore(dragging, current.nextSibling);
                                    } else {
                                        current.parentNode.insertBefore(dragging, current);
                                    }
                                    contentWrapper.querySelector("button.update").style.display = "";
                                }
                            });
                        });
                    }
                    this.emitEvent("track_list_loaded");
                })
                .catch((error) => {
                    Globals.SHOW_ALL_CONSOLE_LOG && console.log({ message: error.message });
                    jQuery(".js-critical-error").show();
                });
        }
    }

    // const orderedTracks = Array.from(contentWrapper.querySelectorAll("#tracksSection .tracks-list-body .track-item")).map(
    //     (item) => item.dataset.id
    // );
    // _this.changeTracksPlaylist(orderedTracks, playlist.data);

    changeTracksPlaylist(tracks, playlist) {
        playlist.Tracks = tracks;
        this.editPlaylist(playlist);
    }

    getAddTrackMyPlaylistList(userManager) {
        const list = [];
        userManager.userPlaylists.map((item) => {
            const playlist = new Playlist(item);
            list.push(playlist.renderAddTrackMyplaylistItem(this));
        });
        return list;
    }

    renderMyplaylistsList(userManager) {
        const container = document.querySelector("#playlistsMenu");
        const list = container.querySelector(".nav-myplaylists");
        list.textContent = "";
        userManager.userPlaylists.map((item) => {
            const playlist = new Playlist(item);
            list.appendChild(playlist.renderMyplaylistItem(this));
        });
        jQuery("#loadingModal").modal("hide");
        jQuery("#loadingModal .js-preloader").hide();
    }

    renderHeaderList(elements) {
        const container = document.querySelector("#playlistsHeaderSection");
        const list = container.querySelector(".row");
        list.textContent = "";
        this.shuffle(this.data).filter((playlist, index) => index < elements && list.appendChild(playlist.renderHeaderListItem()));
    }

    renderFirstpageList(limit = 6) {
        const container = document.querySelector("#playlistsSection");
        const list = container.querySelector(".swiper-wrapper");
        list.textContent = "";
        const elements = limit;
        this.data.map((playlist, index) => index < elements && list.appendChild(playlist.renderSwiperListItem()));
    }

    renderList() {
        const container = document.querySelector("#playlistsListSection");
        const list = container.querySelector(".list-wrapper");
        list.textContent = "";
        this.data.filter((playlist) => list.appendChild(playlist.renderListItem()));
    }

    renderSingle(id, tracks, userManager) {
        this.getFull(id, tracks, userManager);
    }

    setupNewPlaylist() {
        const playlistModal = document.querySelector("#playlistModal");
        const form = playlistModal.querySelector("form");
        form.addEventListener("submit", (event) => {
            event.preventDefault();

            const data = new FormData(event.target);
            const playlist_name = data.get("plName");
            const track_id = data.get("plTrackId");

            jQuery("#playlistModal").modal("hide");
            document.querySelector("#playlistModal input[name=plTrackId]").value = 0;

            jQuery("#loadingModal").modal("show");
            jQuery("#loadingModal .js-preloader").show();

            if (Globals.SHOW_ALL_CONSOLE_LOG) console.log("New Playlist - Start");

            document.querySelector("#playlistsMenu .nav-myplaylists").innerHTML = `<div class="js-preloader small"><div class="spinner"></div></div>`;

            const token = this.getCookie("user_token");
            if (token) {
                fetch(`${Globals.WS_URL}?mode=PLAYLIST.NEW&token=${token}&playlist_name=${playlist_name}&track_id=${track_id}`)
                    //  fetch(`/apisounzone/setupNewPlaylist/?token=${token}&playlist_name=${playlist_name}&track_id=${track_id}`)
                    .then(this.handleResponse)
                    .then((result) => {
                        if (result.error) {
                            if (Globals.SHOW_ALL_CONSOLE_LOG) console.log("New Playlist - ERROR: " + result.error);
                            return;
                        }
                        if (result.result && result.data) {
                            if (Globals.SHOW_ALL_CONSOLE_LOG) console.log("New Playlist - Created OK");
                            if (Globals.SHOW_ALL_CONSOLE_LOG) console.log(result);
                            this.emitEvent("playlists_update");
                        }
                    })
                    .catch((error) => {
                        Globals.SHOW_ALL_CONSOLE_LOG && console.log({ message: error.message });
                        jQuery(".js-critical-error").show();
                    });
            } else {
                if (Globals.SHOW_ALL_CONSOLE_LOG) console.log("New Playlist - NO TOKEN");
            }
        });
    }

    addTrackToPlaylist(id, track) {
        if (Globals.SHOW_ALL_CONSOLE_LOG) console.log("Add Track To Playlist - Start");

        jQuery("#loadingModal").modal("show");
        jQuery("#loadingModal .js-preloader").show();

        const token = this.getCookie("user_token");
        if (token) {
            fetch(`${Globals.WS_URL}?mode=PLAYLIST.ADD&token=${token}&playlist_id=${id}&track_id=${track.ID}`)
                .then(this.handleResponse)
                .then((result) => {
                    if (result.error) {
                        if (Globals.SHOW_ALL_CONSOLE_LOG) console.log("Add Track To Playlist - ERROR: " + result.error);
                        return;
                    }
                    if (result.result && result.data) {
                        if (Globals.SHOW_ALL_CONSOLE_LOG) console.log("Add Track To Playlist - Created OK");
                        if (Globals.SHOW_ALL_CONSOLE_LOG) console.log(result);

                        jQuery("#loadingModal").modal("hide");
                        jQuery("#loadingModal .js-preloader").hide();

                        jQuery("#playlistAddTrackOKModal").modal("show");
                        document.querySelector("#playlistAddTrackOKModal .playlist-name").textContent = result.data.playlists[0].Name;
                        document.querySelector("#playlistAddTrackOKModal .track-name").textContent = track.Name;
                        setTimeout(() => {
                            jQuery("#playlistAddTrackOKModal").modal("hide");
                            document.querySelector("#playlistAddTrackOKModal .playlist-name").textContent = "";
                            document.querySelector("#playlistAddTrackOKModal .track-name").textContent = "";
                        }, 3000);

                        //this.emitEvent("playlists_update");
                    }
                })
                .catch((error) => {
                    Globals.SHOW_ALL_CONSOLE_LOG && console.log({ message: error.message });
                    jQuery(".js-critical-error").show();
                });
        } else {
            if (Globals.SHOW_ALL_CONSOLE_LOG) console.log("Add Track To Playlist - NO TOKEN");
        }
    }

    showRemoveDialog(id) {
        if (Globals.SHOW_ALL_CONSOLE_LOG) console.log("Show Dialog Remove Playlist - Start");

        jQuery("#playlistDeleteModal").modal("show");

        document.querySelector("#playlistDeleteModal input[name=plTrackId]").value = id;

        document.querySelector("#playlistDeleteModal button.delete-playlist").addEventListener("click", (event) => {
            jQuery("#playlistDeleteModal").modal("hide");
            const id = document.querySelector("#playlistDeleteModal input[name=plTrackId]").value;
            document.querySelector("#playlistDeleteModal input[name=plTrackId]").value = "";
            this.removePlaylist(id);
        });
    }

    removePlaylist(id) {
        if (Globals.SHOW_ALL_CONSOLE_LOG) console.log("Remove Playlist - Start");

        jQuery("#loadingModal").modal("show");
        jQuery("#loadingModal .js-preloader").show();

        document.querySelector("#playlistsMenu .nav-myplaylists").innerHTML = `<div class="js-preloader small"><div class="spinner"></div></div>`;

        const token = this.getCookie("user_token");
        if (token) {
            fetch(`${Globals.WS_URL}?mode=PLAYLIST.REMOVE&token=${token}&playlist_id=${id}`)
                .then(this.handleResponse)
                .then((result) => {
                    if (result.error) {
                        if (Globals.SHOW_ALL_CONSOLE_LOG) console.log("Remove Playlist - ERROR: " + result.error);
                        return;
                    }
                    if (result.result) {
                        if (Globals.SHOW_ALL_CONSOLE_LOG) console.log("Remove Playlist - Delete OK");

                        const urlParams = this.getUrlParams();

                        if (parseInt(urlParams.get("id")) === result.result["playlist.deleted"]) {
                            window.location.href = "/find-music";
                        }

                        this.emitEvent("playlists_update");
                    }
                })
                .catch((error) => {
                    Globals.SHOW_ALL_CONSOLE_LOG && console.log({ message: error.message });
                    jQuery(".js-critical-error").show();
                });
        } else {
            if (Globals.SHOW_ALL_CONSOLE_LOG) console.log("Remove Playlist - NO TOKEN");
        }
    }

    showRemoveTrackDialog(track_id, playlist) {
        Globals.isRemoveTrackFromPlaylist = true;

        // this.removeTrackFromPlaylist(track_id, playlist);

        //*
        if (Globals.SHOW_ALL_CONSOLE_LOG) console.log("Show Dialog Remove Track - Start");

        jQuery("#playlistRemoveTrackModal").modal("show");

        document.querySelector("#playlistRemoveTrackModal button.btn-cancel").addEventListener("click", (event) => {
            Globals.isRemoveTrackFromPlaylist = false;
        });

        document.querySelector("#playlistRemoveTrackModal button.remove-track").addEventListener("click", (event) => {
            jQuery("#playlistRemoveTrackModal").modal("hide");
            this.removeTrackFromPlaylist(track_id, playlist);
        });
        //*/
    }

    removeTrackFromPlaylist(track_id, playlist) {
        playlist.Tracks.splice(playlist.Tracks.indexOf(track_id), 1);
        this.editPlaylist(playlist);
    }

    editPlaylist(playlist) {
        if (Globals.SHOW_ALL_CONSOLE_LOG) console.log("Edit Playlist - Start");

        jQuery("#loadingModal").modal("show");
        jQuery("#loadingModal .js-preloader").show();

        const token = this.getCookie("user_token");
        if (token) {
            fetch(`${Globals.WS_URL}?mode=PLAYLIST.EDIT&token=${token}&playlist_id=${playlist.ID}&tracks=${playlist.Tracks.join(",")}`)
                .then(this.handleResponse)
                .then((result) => {
                    if (result.error) {
                        if (Globals.SHOW_ALL_CONSOLE_LOG) console.log("Edit Playlist - ERROR: " + result.error);
                        return;
                    }
                    if (result.result) {
                        if (Globals.SHOW_ALL_CONSOLE_LOG) console.log("Edit Playlist - Edit OK");

                        this.emitEvent("playlists_update");
                    }
                    // 230719
                    Globals.isRemoveTrackFromPlaylist = false;
                    window.location.reload();
                })
                .catch((error) => {
                    Globals.SHOW_ALL_CONSOLE_LOG && console.log({ message: error.message });
                    jQuery(".js-critical-error").show();
                });
        } else {
            if (Globals.SHOW_ALL_CONSOLE_LOG) console.log("Edit Playlist - NO TOKEN");
        }
    }

    // SetMeta(item) {
    //     document.querySelector('meta[property="og:title"]').setAttribute("content", item.Name);
    //     document.querySelector('meta[name="twitter:title"]').setAttribute("content", item.Name);
    //     document.querySelector('meta[name="title"]').setAttribute("content", item.Name);

    //     document.querySelector('meta[property="og:description"]').setAttribute("content", item.Name + '- Playlist');
    //     document.querySelector('meta[name="twitter:description"]').setAttribute("content", item.Name + '- Playlist');
    //     document.querySelector('meta[name="description"]').setAttribute("content", item.Name + '- Playlist');

    //     if (item.Image.Medium) {
    //         document.querySelector('meta[property="og:image"]').setAttribute("content", item.Image.Medium);
    //         document.querySelector('meta[name="twitter:image:src"]').setAttribute("content", item.Image.Medium);
    //     }

    // }

    dispose() {
        this.data = [];
    }
}
